module.exports = '<svg width="19" height="32" viewBox="0 0 19 32"><path d="M14.282 31.523a1.493 1.493 0 0 0 2.189 0l2.186-2.294a1.669 1.669 0 0 0 0-2.288L8.113 16.045l10.63-10.989a1.673 1.673 0 0 0 0-2.291L16.557.471a1.504 1.504 0 0 0-2.189 0L.448 14.897a1.683 1.683 0 0 0 0 2.294l13.834 14.333z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-2.js
// module id = 1213
// module chunks = 14